import React from 'react';
import {
  components as DefaultSelectComponents,
  ValueContainerProps,
} from 'react-select';
import _get from 'lodash/get';
import Chip, { ChipTypes } from '@lib/components/Chip/Chip';
import { colorToChipType } from '@lib/components/Chip/utils/colorEnum';
import styles from '../Select.module.scss';

export default function ChipValueContainer(
  props: ValueContainerProps,
): React.ReactElement {
  const { children, ...valueContainerProps } = props;
  const { selectProps } = valueContainerProps;
  const value = _get(selectProps, 'value');
  const isDisabled = _get(selectProps, 'isDisabled');
  const label = _get(value, 'label');
  const color = (_get(value, ['data', 'color']) ||
    _get(value, 'color')) as string;

  if (Array.isArray(children) && label && color) {
    const type = isDisabled ? ChipTypes.chipDisabled : colorToChipType(color);
    return (
      // @ts-ignore
      <DefaultSelectComponents.ValueContainer
        {...valueContainerProps}
        className={styles.valueContainer}
      >
        <span className={styles.singleValueWrap}>
          <Chip type={type} label={label} leftIcon="circle" />
          {/* {children[0]} */}
          <span>{children[1]}</span>
        </span>
      </DefaultSelectComponents.ValueContainer>
    );
  }

  return (
    // @ts-ignore
    <DefaultSelectComponents.ValueContainer
      {...valueContainerProps}
      className={styles.valueContainer}
    >
      {children}
    </DefaultSelectComponents.ValueContainer>
  );
}
